import { render, staticRenderFns } from "./Myinfo.vue?vue&type=template&id=76720811&scoped=true&"
import script from "./Myinfo.vue?vue&type=script&lang=js&"
export * from "./Myinfo.vue?vue&type=script&lang=js&"
import style0 from "./Myinfo.vue?vue&type=style&index=0&id=76720811&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76720811",
  null
  
)

export default component.exports